export default __webpack_public_path__ + "a61eaf4c2e4d44d6db6a576706e9e6ae.ttf";